var map = {
	"./content/auto-article": 7491,
	"./content/auto-article.js": 7491,
	"./content/auto-default": 4120,
	"./content/auto-default.js": 4120,
	"./content/auto-genericcontent": 7135,
	"./content/auto-genericcontent.js": 7135,
	"./content/auto-leisuremangatranslation": 9893,
	"./content/auto-leisuremangatranslation.js": 9893,
	"./content/auto-memo": 6507,
	"./content/auto-memo.js": 6507,
	"./content/auto-memolist": 4979,
	"./content/auto-memolist.js": 4979,
	"./content/auto-missing": 6269,
	"./content/auto-missing.js": 6269,
	"./content/auto-workspace": 1332,
	"./content/auto-workspace.js": 1332,
	"./layouts/page-double": 3658,
	"./layouts/page-double.js": 3658,
	"./layouts/page-error": 7245,
	"./layouts/page-error.js": 7245,
	"./layouts/page-explore": 5672,
	"./layouts/page-explore.js": 5672,
	"./layouts/page-leisure-error": 8807,
	"./layouts/page-leisure-error.js": 8807,
	"./layouts/page-leisure-simple": 8187,
	"./layouts/page-leisure-simple-login": 991,
	"./layouts/page-leisure-simple-login.js": 991,
	"./layouts/page-leisure-simple.js": 8187,
	"./layouts/page-maintenance": 8432,
	"./layouts/page-maintenance-leisure": 6754,
	"./layouts/page-maintenance-leisure.js": 6754,
	"./layouts/page-maintenance.js": 8432,
	"./layouts/page-mirror": 5428,
	"./layouts/page-mirror.js": 5428,
	"./layouts/page-vanilla": 6416,
	"./layouts/page-vanilla.js": 6416,
	"./layouts/page-wide": 1384,
	"./layouts/page-wide.js": 1384,
	"./layouts/partial-head": 1803,
	"./layouts/partial-head.js": 1803,
	"./store/sn-store": 7317,
	"./store/sn-store.js": 7317,
	"./utils/add-component": 2062,
	"./utils/add-component.js": 2062,
	"./utils/add-component.test": 6914,
	"./utils/add-component.test.js": 6914,
	"./utils/context-binding": 7328,
	"./utils/context-binding.js": 7328,
	"./utils/deep-equal": 9476,
	"./utils/deep-equal.js": 9476,
	"./utils/lazyload-image": 7481,
	"./utils/lazyload-image.js": 7481,
	"./utils/show-debuginfo": 9192,
	"./utils/show-debuginfo.js": 9192,
	"./utils/use-list-sorting": 9620,
	"./utils/use-list-sorting.js": 9620,
	"./widgets/auto-default": 3660,
	"./widgets/auto-default.js": 3660,
	"./widgets/auto-widgetcontentcollection": 5068,
	"./widgets/auto-widgetcontentcollection.js": 5068,
	"./widgets/auto-widgetcontentview": 1789,
	"./widgets/auto-widgetcontentview.js": 1789,
	"./widgets/auto-widgetlogin": 3752,
	"./widgets/auto-widgetlogin.js": 3752,
	"./widgets/auto-widgetsimpletext": 3832,
	"./widgets/auto-widgetsimpletext.js": 3832,
	"./widgets/manual-content-manga": 7456,
	"./widgets/manual-content-manga.js": 7456,
	"./widgets/manual-content-simple": 7540,
	"./widgets/manual-content-simple.js": 7540,
	"./widgets/manual-list-banner": 4597,
	"./widgets/manual-list-banner.js": 4597,
	"./widgets/manual-list-breadcrumb": 7270,
	"./widgets/manual-list-breadcrumb.js": 7270,
	"./widgets/manual-list-manga": 6659,
	"./widgets/manual-list-manga-half": 4449,
	"./widgets/manual-list-manga-half.js": 4449,
	"./widgets/manual-list-manga.js": 6659,
	"./widgets/manual-list-menu": 800,
	"./widgets/manual-list-menu-logo": 3814,
	"./widgets/manual-list-menu-logo.js": 3814,
	"./widgets/manual-list-menu.js": 800,
	"./widgets/manual-list-news": 464,
	"./widgets/manual-list-news-half": 9820,
	"./widgets/manual-list-news-half.js": 9820,
	"./widgets/manual-list-news-third": 1568,
	"./widgets/manual-list-news-third.js": 1568,
	"./widgets/manual-list-news.js": 464,
	"./widgets/manual-list-review": 6119,
	"./widgets/manual-list-review.js": 6119,
	"./widgets/manual-list-test": 839,
	"./widgets/manual-list-test.js": 839,
	"./widgets/manual-list-translation-third": 4060,
	"./widgets/manual-list-translation-third.js": 4060,
	"./widgets/manual-list-translations": 5339,
	"./widgets/manual-list-translations.js": 5339,
	"./widgets/manual-news-half": 7335,
	"./widgets/manual-news-half.js": 7335,
	"./widgets/manual-plugin-disqus": 7557,
	"./widgets/manual-plugin-disqus.js": 7557,
	"./widgets/manual-plugin-fbcomments": 9728,
	"./widgets/manual-plugin-fbcomments.js": 9728,
	"./widgets/manual-review-manga": 4627,
	"./widgets/manual-review-manga.js": 4627,
	"./widgets/manual-review-simple": 201,
	"./widgets/manual-review-simple.js": 201,
	"./widgets/nested-list-manga-item": 922,
	"./widgets/nested-list-manga-item.js": 922,
	"./widgets/nested-list-news-item": 2461,
	"./widgets/nested-list-news-item-leisurearticle": 6257,
	"./widgets/nested-list-news-item-leisurearticle.js": 6257,
	"./widgets/nested-list-news-item-leisurebookreview": 4078,
	"./widgets/nested-list-news-item-leisurebookreview.js": 4078,
	"./widgets/nested-list-news-item-leisuremangareview": 9239,
	"./widgets/nested-list-news-item-leisuremangareview.js": 9239,
	"./widgets/nested-list-news-item-leisuremangatranslation": 8484,
	"./widgets/nested-list-news-item-leisuremangatranslation.js": 8484,
	"./widgets/nested-list-news-item.js": 2461,
	"./widgets/nested-list-translations-item": 1764,
	"./widgets/nested-list-translations-item.js": 1764,
	"./widgets/nested-news-item": 2400,
	"./widgets/nested-news-item.js": 2400,
	"./widgets/nested-review-list-image": 990,
	"./widgets/nested-review-list-image.js": 990,
	"./widgets/nested-review-list-item": 4724,
	"./widgets/nested-review-list-item.js": 4724,
	"./widgets/nested-review-related-leisuremangatranslation": 9750,
	"./widgets/nested-review-related-leisuremangatranslation.js": 9750,
	"./widgets/nested-review-related-softlink": 9048,
	"./widgets/nested-review-related-softlink.js": 9048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2027;